module.exports = __webpack_public_path__ + "exo-latin-100italic.d8d1b8142312dc8661ca.woff2";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-100italic.woff2
// module id = ../../../../typeface-exo/files/exo-latin-100italic.woff2
// module chunks = styles